import { HTMLAttributes } from 'react';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { isString } from 'lodash';

export interface IStackProps extends HTMLAttributes<HTMLDivElement> {
  'data-qa'?: string;
  spacing?: string | number;
  direction?: 'row' | 'column';
}

export const Stack = ({ spacing, direction = 'column', ...rest }: IStackProps) => {
  let childrenStyle: FlattenSimpleInterpolation;

  if (spacing) {
    // NOTE: Would love to adopt a `theme.spacing` approach seen in many component libraries. That way we could more easily enforce consistent styles throughout the site - IS 5/28/22
    const _spacing = isString(spacing) ? spacing : `${spacing}px`;

    childrenStyle = css`
    > :where(:not(:first-child)) {
      margin-${direction === 'row' ? 'left' : 'top'}: ${_spacing};
    }
    `;
  }

  return <Stack.Root {...rest} $direction={direction} $childrenStyle={childrenStyle} />;
};

interface IStackRootStyleProps {
  $direction: 'row' | 'column';
  $childrenStyle?: FlattenSimpleInterpolation;
}

Stack.Root = styled.div<IStackRootStyleProps>`
  display: flex;
  flex-direction: ${({ $direction }) => $direction}};
  ${({ $childrenStyle }) => $childrenStyle}
`;
